import { HttpClient } from "@/App/services/HttpClient";
import { FeedbackPayload, FeedbackService } from "@twiage/feedback-form";
import { version, name } from "../../../../../package.json";

class Feedback implements FeedbackService {
  sendFeedback(feedback: FeedbackPayload): Promise<Record<string, unknown>> {
    const { message } = feedback;
    return HttpClient.post("/v4/feedback", {
      message,
      clientInfo: {
        client: name,
        clientVersion: version,
      },
    });
  }
}

export default new Feedback();
